module.exports = __webpack_public_path__ + "static/scale-model-of-salisbury-house-&-gardens-in-des-moines-iowa-84c82c647f486d06d4414e91a5825adf.png";